import React from "react";
import { Icon, Button, WithTooltip, Tooltip } from "@abb/abb-common-ux-react";
import { IInstrumentDetails } from '../../models/measurement/InstrumentDetails';
import { ABB_PLAY, ABB_STOP } from '../../utilities/IconConstants';
import { IKeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import { Status } from "../../models/sample/Status";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";

interface ITabItems {
    instrumentDetails?: IInstrumentDetails[];
    keyedInDetails?: IKeyedInDetails[];
    CalculatedDetails?: ICalculatedDetails[];
    selectInstrument?: number;
    selectedKeyedIn?: number;
    selectedCalculated?: number;
    onSelectTab: (index: number, id: string) => void;
    onSelectKeyedInTab: (index: number, id: string) => void;
    isFullScreenVisible: boolean;
    onSelectCalculatedTab?: (index: number, id: string) => void;
    keyedInSection?: boolean;
    calculatedSection?: boolean;
    meauredSection?: boolean;
    startInstrumentMeasurement: (instrumentId: string) => void;
    stopInstrumentMeasurement: (instrumentId: string) => void;
    resumeInstrumentMeasurement: (instrumentId: string) => void;
    remeasureInstrumentMeasurement: (instrumentId: string) => void;
    stopMeasurement?: boolean;
    pausedMeasurement?: boolean;
}

export default class TabItems extends React.Component<ITabItems> {
    private onLeft() {
        this.scrollLeft(document.getElementById("content-data"), -400, 1000);
    }

    private onRight() {
        this.scrollLeft(document.getElementById("content-data"), 400, 1000);
    }

    private scrollLeft(element: any, change: any, duration: any) {
        const start = element.scrollLeft;
        let currentTime = 0;
        const increment = 20;
        const easeInOutQuad = (t: any, b: any, c: any, d: any) => {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };
        const animateScroll = () => {
            currentTime += increment;
            const val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    public render() {
        const keyedInData = this.props.keyedInDetails.map((data, index) => {
            return (
                <Translation>

                    {

                        t =>
                            <div
                                className={
                                    this.props.selectedKeyedIn === index
                                        ? "internal internal-background"
                                        : "internal"
                                }
                                style={{ width: this.props.isFullScreenVisible ? "25%" : "31.75%" }}
                                key={index}
                                onClick={() => this.props.onSelectKeyedInTab(index, data.id)}
                            >
                                <div>
                                    <span className="float-left tab-title">{data.name}</span>
                                    <span className="float-right" />
                                    <div className="clearfix" />

                                </div>
                                <div className="progress my-1" style={{ height: 8 }}>
                                    <div
                                        className="progress-bar"
                                        style={{ width: data.completionPercentage }}
                                        role="progressbar"
                                        aria-valuenow={0}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                    />
                                </div>
                                <p>
                                    {data.counts !== undefined && data.counts.length > 0 &&
                                        <span className="float-right measurement-status">{data.counts[0].completedCounts}({data.counts[0].totalCounts})</span>}
                                    {data.counts[0].completedCounts === data.counts[0].totalCounts ? <span className="float-left measurement-status" style={{ color: "blue" }}>{t(Status.COMPLETED)}</span> : ""}
                                </p>
                                <div className="clearfix" />
                            </div>}

                </Translation>


            );
        });


        const measuredData = (this.props.instrumentDetails || []).map((data, index) => {
            return (
                <Translation>

                    {

                        t =>
                            <div
                                className={
                                    this.props.selectInstrument === index
                                        ? "internal internal-background"
                                        : "internal"
                                }
                                style={{ width: this.props.isFullScreenVisible ? "25%" : "31.75%" }}
                                key={index}
                                onClick={() => this.props.onSelectTab(index, data.id)}
                            >
                                <div>
                                    <span className="float-left tab-title">{data.name}</span>
                                    {data.status !== undefined && data.status.name === Status.PENDING && <button
                                        className="float-right btn-abb-class-play"
                                        disabled={this.props.pausedMeasurement ||
                                            this.props.stopMeasurement ? true : false}
                                        onClick={() => this.props.startInstrumentMeasurement(data.id)}
                                    >
                                        <WithTooltip>
                                            <Icon name={data.iconStatus.name} sizeClass="small"
                                                style={{
                                                    color: 'white',
                                                    background: this.props.pausedMeasurement ||
                                                        this.props.stopMeasurement ? '' : data.iconStatus.color
                                                }}
                                            />
                                            <Tooltip className="nav-tooltip">
                                                <p>{t(CONSTANTS.BUTTON_START)}</p>
                                            </Tooltip>
                                        </WithTooltip>
                                    </button>}
                                    {data.status !== undefined && data.status.name === Status.INUSE && <button
                                        className="float-right btn-abb-class-play"
                                        disabled={this.props.pausedMeasurement ||
                                            this.props.stopMeasurement ? true : false}
                                        onClick={() => this.props.startInstrumentMeasurement(data.id)}
                                    >
                                        <WithTooltip>
                                            <Icon name={data.iconStatus.name} sizeClass="small"
                                                style={{
                                                    background: 'white',
                                                    color: this.props.pausedMeasurement ||
                                                        this.props.stopMeasurement ? '' : data.iconStatus.color
                                                }}
                                            />
                                            <Tooltip className="nav-tooltip">
                                                <p>{t(CONSTANTS.BUTTON_WAITING)}</p>
                                            </Tooltip>
                                        </WithTooltip>
                                    </button>}

                                    <div>{data.status !== undefined && data.status.name === Status.MEASURING && <button
                                        className="float-right btn-abb-class"
                                        onClick={() => this.props.stopInstrumentMeasurement(data.id)}
                                    >
                                        <WithTooltip>
                                            <Icon name={data.iconStatus.name} sizeClass="small"
                                                style={{
                                                    color: 'white',
                                                    background: data.iconStatus.color
                                                }}
                                            />
                                            <Tooltip className="nav-tooltip">
                                                <p>{t(CONSTANTS.BUTTON_STOP)}</p>
                                            </Tooltip>
                                        </WithTooltip>
                                    </button>}</div>

                                    {data.status !== undefined && (data.status.name === Status.PAUSED || data.status.name === Status.STOPPED) && <button
                                        className="float-right btn-abb-class"
                                        disabled={this.props.pausedMeasurement ||
                                            this.props.stopMeasurement ? true : false}
                                        onClick={() => this.props.remeasureInstrumentMeasurement(data.id)}
                                    >
                                        <WithTooltip>
                                            <Icon name={data.iconStatus.name} sizeClass="small"
                                                style={this.props.stopMeasurement || this.props.pausedMeasurement ? null : {
                                                    color: 'blue',
                                                }}
                                            />
                                            <Tooltip className="nav-tooltip">
                                                <p>{data.status.name === Status.PAUSED ? t(CONSTANTS.BUTTON_START) : t(CONSTANTS.BUTTON_REMEASURE)}</p>
                                            </Tooltip>
                                        </WithTooltip>
                                    </button>}

                                    {data.status !== undefined && data.status.name === Status.COMPLETED && <button
                                        className="float-right btn-abb-class"
                                        disabled={this.props.pausedMeasurement ||
                                            this.props.stopMeasurement ? true : false}
                                        onClick={() => this.props.remeasureInstrumentMeasurement(data.id)}
                                    >
                                        <WithTooltip>
                                            <Icon name={data.iconStatus.name} sizeClass="small"
                                                style={this.props.stopMeasurement || this.props.pausedMeasurement ? null : { color: 'blue' }}
                                            />
                                            <Tooltip className="nav-tooltip">
                                                <p>{t(CONSTANTS.BUTTON_REMEASURE)}</p>
                                            </Tooltip>
                                        </WithTooltip>
                                    </button>}

                                    <div className="clearfix" />
                                </div>
                                <div className="progress my-1" style={{ height: 8 }} onClick={() => this.props.onSelectTab(index, data.id)}>
                                    <div
                                        className="progress-bar"
                                        style={{ width: data.completionPercentage }}
                                        role="progressbar"
                                        aria-valuenow={0}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                    />
                                </div>

                                <p>
                                    {data.status !== undefined && <span className="float-left measurement-status" style={{ color: data.status.color }}>{t(data.status.name)}</span>}
                                    <span className="float-right measurement-status">{data.count.completedCounts}({data.count.totalCounts})</span>
                                </p>
                                <div className="clearfix" />
                            </div>}

                </Translation>


            );
        });

        const calculatedData = (this.props.CalculatedDetails || []).map((data, index) => {
            return <div key={index}
                className={this.props.selectedCalculated === index ? "internal internal-background" : "internal"}
                style={{ width: this.props.isFullScreenVisible ? "20%" : "31.75%" }}
                onClick={() => this.props.onSelectCalculatedTab(index, data.id)}
            >
                <div>
                    <span className="float-left tab-title">{data.name}</span>
                    <span className="float-right" />
                    <div className="clearfix" />

                </div>
                <div className="progress my-1" style={{ height: 8 }}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        aria-valuenow={0}
                        style={{ width: data.calculatedValues.length ? "100%" : "0%" }}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    />
                </div>
                <p>
                    <span className="float-left measurement-status"></span>
                </p>
                <div className="clearfix" />
            </div>
        })

        return (
            <div className="tabs">
                <div className="icon-wrapper float-left">
                    <div className="icon-background cursor" onClick={() => this.onLeft()}>
                        <div className="pt-4 ml-2">
                            <Icon name="abb/left" />
                        </div>
                    </div>
                </div>
                <div className="center-content" id="content-data">
                    {this.props.meauredSection ? measuredData : null}
                    {this.props.keyedInSection ? keyedInData : null}
                    {this.props.calculatedSection ? calculatedData : null}
                </div>

                <div className="icon-wrapper icon-wrapper-right float-right">
                    <div className="icon-background cursor"
                        onClick={() => this.onRight()}>
                        <div className="pt-4 ml-2"><Icon name="abb/right" /></div>
                    </div>
                </div>
                {this.props.children}
            </div>
        )
    }

}

